export default (params) => ({
  trigger: {
    name: 'search.search',
    params: params,
  },
  config: {
    schema: {
      search_term: {
        type: 'string',
      },
      method: {
        enum: [
          'enter',
          'click',
          'typing',
        ],
      },
    },
    event: {
      name: 'search',
      params: {
        sub_feature: 'header',
      },
    },
  },
});
